import { catchFaceOfDeepWeb } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/catchFaceDrawer/catchFaceOfDeepWeb'
import { catchFaceOfShallowWeb } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/catchFaceDrawer/catchFaceOfShallowWeb'
import { catchFaceOfThumbParts } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/catchFaceDrawer/catchFaceOfThumbParts'

// 浅めのウェブ時の捕球面
const shallowWebCatchFaceDrawer = (ctx: CanvasRenderingContext2D, catchFaceColor: string, stitchColor: string): void => {
  catchFaceOfThumbParts(ctx, catchFaceColor)
  catchFaceOfShallowWeb(ctx, catchFaceColor, stitchColor)
}
// 普通・深めのウェブ時の捕球面
const normalWebCatchFaceDrawer = (ctx: CanvasRenderingContext2D, catchFaceColor: string, stitchColor: string): void => {
  catchFaceOfThumbParts(ctx, catchFaceColor)
  catchFaceOfDeepWeb(ctx, catchFaceColor, stitchColor)
}

export const catchFaceDrawer = (ctx: CanvasRenderingContext2D, catchFaceColor: string, stitchColor: string, productNumber: string): void => {
  const isShallowWeb = productNumber === 'AKG-JS2'

  if (isShallowWeb) {
    shallowWebCatchFaceDrawer(ctx, catchFaceColor, stitchColor)
  } else {
    normalWebCatchFaceDrawer(ctx, catchFaceColor, stitchColor)
  }
}
